import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const ReportListing = ({ onReport }) => {
  const [details, setDetails] = useState('');
  const { carDetails: listingId } = useSelector((state) => state.details); // Listing ID

  const handleSubmit = async (e) => {
    e.preventDefault();
    onReport({ listingId: listingId?.id, details });
    setDetails('');
  };

  return (
    <div
      id='report_listing_submit_modal'
      className='hp-modal'
      style={{ display: 'inline-block' }}
    >
      <form onSubmit={handleSubmit} className='hp-form hp-form--review-submit'>
        <div className='hp-form__fields'>
          <input
            type='hidden'
            name='listing'
            value={listingId?.id}
            className='hp-field hp-field--hidden'
          />
          <div className='hp-form__field hp-form__field--textarea hp-field-label-text'>
            <p>
              Please provide details that will help us improve this listing or
              let us know if this listing violates our community standards.{' '}
            </p>
            <label className='hp-field__label hp-form__label'>
              <span>Details</span>
            </label>
            <textarea
              name='text'
              maxLength='2048'
              required
              className='hp-field hp-field--textarea'
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          </div>
        </div>
        <div className='hp-form__footer'>
          <button
            type='submit'
            className='hp-form__button button-primary alt button hp-field hp-field--submit'
          >
            <span>Report Listing</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReportListing;
